(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bie-apres-hero"]) return;
  try {
    
function setupApresVideos(root=document){
 root.querySelectorAll('.bie-apres-hero').forEach(hero=>{
  if(hero.dataset.ready)return;
  hero.dataset.ready='true';
  const video=hero.querySelector('video'),button=hero.querySelector('.bie-apres-hero__pause');
  if(!video||!button)return;
  const sync=()=>{button.textContent=video.paused?'▶':'Ⅱ';button.setAttribute('aria-label',video.paused?button.dataset.play:button.dataset.pause)};
  video.addEventListener('play',sync);video.addEventListener('pause',sync);
  video.muted=false;
  video.volume=1;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){video.autoplay=false;video.pause()}
  else{video.play().catch(sync)}
  button.addEventListener('click',()=>{if(video.paused){video.muted=false;video.play().catch(sync)}else{video.pause()}});
  sync();
 });
}
setupApresVideos();
document.addEventListener('shopify:section:load',event=>setupApresVideos(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bie-apres-product"]) return;
  try {
    

function bieSaleInstant(date,time){
 if(!/^\d{4}-\d{2}-\d{2}$/.test(date)||!/^\d{2}:\d{2}$/.test(time))return NaN;
 const desired=Date.parse(date+'T'+time+':00Z');
 if(!Number.isFinite(desired))return NaN;
 const format=new Intl.DateTimeFormat('en-CA',{timeZone:'America/Toronto',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
 let instant=desired;
 for(let i=0;i<4;i++){
  const p=Object.fromEntries(format.formatToParts(new Date(instant)).map(x=>[x.type,x.value]));
  const represented=Date.parse(p.year+'-'+p.month+'-'+p.day+'T'+p.hour+':'+p.minute+':'+p.second+'Z');
  const delta=desired-represented;
  if(delta===0)return instant;
  instant+=delta;
 }
 return NaN;
}
function bieSetupSale(root=document){
 root.querySelectorAll('.bie-apres-product[data-sale-scheduled]').forEach(section=>{
  if(section.dataset.saleReady)return;
  section.dataset.saleReady='true';
  if(section.dataset.saleScheduled!=='true'){section.removeAttribute('data-sale-pending');return}
  const opens=bieSaleInstant(section.dataset.saleDate,section.dataset.saleTime);
  if(!Number.isFinite(opens))return;
  function update(){
   if(!section.isConnected)return;
   const remaining=opens-Date.now();
   section.toggleAttribute('data-sale-pending',remaining>0);
   if(remaining>0)setTimeout(update,Math.min(remaining,1000));
  }
  update();
 });
}
bieSetupSale();
document.addEventListener('shopify:section:load',event=>bieSetupSale(event.target));



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bie-fixture-studio"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('bie-fixture')) {
  customElements.define('bie-fixture', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.tabs = [...this.querySelectorAll('[data-fixture-tab]')];
      this.panels = [...this.querySelectorAll('[data-fixture-panel]')];
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.selectTab(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next !== undefined) {
            event.preventDefault();
            this.selectTab(next);
            this.tabs[next].focus();
          }
        });
      });
      this.selectTab(0);
      this.activateOptions();
      this.showMedia(this.dataset.currentMedia);
      this.addEventListener('change', event => {
        if (event.target.matches('[data-fixture-option-value]')) this.updateVariant(event.target);
      });
      this.addEventListener('submit', event => {
        if (!event.target.matches('form[action*="/cart/add"]')) return;
        event.preventDefault();
        if (this.cartPending || this.getAttribute('aria-busy') === 'true' || !this.dataset.currentVariant || this.querySelector('[data-fixture-add]')?.disabled) return;
        void this.addToCart(event.target, event.submitter);
      });
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-fixture-thumb]');
        if (thumb) this.showMedia(thumb.dataset.fixtureThumb);
        const retry = event.target.closest('[data-fixture-retry]');
        if (retry) this.updateVariant(this.querySelector('[data-fixture-option-value]:checked'));
        const button = event.target.closest('[data-fixture-zoom]');
        if (button) {
          const original = button.querySelector('img');
          const dialog = this.querySelector('dialog');
          if (!dialog || !original) return;
          const enlarged = dialog.querySelector('img');
          enlarged.src = button.dataset.fixtureZoom || original.currentSrc || original.src;
          enlarged.alt = original.alt;
          dialog.showModal();
        }
      });
      const dialog = this.querySelector('dialog');
      dialog?.addEventListener('click', event => {
        const bounds = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
      });
    }
    disconnectedCallback() {
      this.variantRequest?.abort();
    }
    activateOptions() {
      const form = this.querySelector('[data-fixture-purchase] form');
      if (form) form.action = this.dataset.cartAddUrl;
      this.querySelectorAll('[data-fixture-option]').forEach(fieldset => { fieldset.disabled = false; });
      const variantId = this.querySelector('[data-fixture-variant-id]');
      if (variantId) variantId.disabled = !this.dataset.currentVariant;
    }
    showMedia(id) {
      const media = [...this.querySelectorAll('[data-fixture-media]')];
      const selected = media.find(panel => panel.dataset.fixtureMedia === String(id)) || media[0];
      media.forEach(panel => {
        panel.hidden = panel !== selected;
        if (panel !== selected) panel.querySelectorAll('video').forEach(video => video.pause());
      });
      this.querySelectorAll('[data-fixture-thumb]').forEach(thumb => {
        thumb.setAttribute('aria-pressed', String(thumb.dataset.fixtureThumb === selected?.dataset.fixtureMedia));
      });
      const hint = this.querySelector('[data-fixture-image-hint]');
      if (hint) hint.hidden = !selected?.querySelector('img');
    }
    async updateVariant(input) {
      if (!input || this.cartPending) return;
      this.variantRequest?.abort();
      const controller = new AbortController();
      this.variantRequest = controller;
      const selectedValues = [...this.querySelectorAll('[data-fixture-option-value]:checked')].map(option => option.dataset.fixtureOptionValue);
      const focusId = document.activeElement === input ? input.id : null;
      const quantity = this.querySelector('input[name="quantity"]')?.value;
      const status = this.querySelector('[data-fixture-availability]');
      this.setAttribute('aria-busy', 'true');
      if (status) status.textContent = status.dataset.loading;
      this.querySelector('[data-fixture-retry]')?.setAttribute('hidden', '');
      this.querySelectorAll('[data-fixture-add], [data-fixture-variant-id], input[name="quantity"]').forEach(control => { control.disabled = true; });
      try {
        const url = new URL(input.dataset.productUrl || this.dataset.productUrl, window.location.origin);
        const currentUrl = new URL(window.location.href);
        ['preview_theme_id', 'view'].forEach(key => {
          if (currentUrl.searchParams.has(key)) url.searchParams.set(key, currentUrl.searchParams.get(key));
        });
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('option_values', selectedValues.join(','));
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Variant request failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = html.getElementById(this.id);
        if (!incoming?.querySelector('[data-fixture-purchase]')) throw new Error('Variant section missing');
        if (controller.signal.aborted) return;
        const oldMedia = this.dataset.currentMedia;
        this.dataset.currentVariant = incoming.dataset.currentVariant;
        this.dataset.currentMedia = incoming.dataset.currentMedia;
        this.dataset.productUrl = incoming.dataset.productUrl;
        this.querySelector('[data-fixture-pricing]').replaceWith(incoming.querySelector('[data-fixture-pricing]'));
        this.querySelector('[data-fixture-purchase]').replaceWith(incoming.querySelector('[data-fixture-purchase]'));
        this.activateOptions();
        const quantityInput = this.querySelector('input[name="quantity"]');
        if (quantityInput && quantity) {
          const min = Number(quantityInput.min) || 1;
          const step = Number(quantityInput.step) || 1;
          const max = quantityInput.max ? Number(quantityInput.max) : Infinity;
          const value = Math.max(min, Math.min(Number(quantity) || min, max));
          quantityInput.value = String(min + Math.floor((value - min) / step) * step);
        }
        if (oldMedia !== this.dataset.currentMedia) this.showMedia(this.dataset.currentMedia);
        if (this.dataset.updateUrl === 'true') {
          if (this.dataset.currentVariant) {
            currentUrl.searchParams.set('variant', this.dataset.currentVariant);
            currentUrl.searchParams.delete('option_values');
          } else {
            currentUrl.searchParams.delete('variant');
            currentUrl.searchParams.set('option_values', selectedValues.join(','));
          }
          window.history.replaceState(window.history.state, '', currentUrl);
        }
        if (focusId && this.contains(document.activeElement) === false) {
          this.querySelectorAll('[data-fixture-option-value]').forEach(option => {
            if (option.id === focusId) option.focus({ preventScroll: true });
          });
        }
      } catch (error) {
        if (controller.signal.aborted) return;
        const currentStatus = this.querySelector('[data-fixture-availability]');
        if (currentStatus) currentStatus.textContent = currentStatus.dataset.error;
        this.querySelector('[data-fixture-retry]')?.removeAttribute('hidden');
      } finally {
        if (this.variantRequest === controller) this.removeAttribute('aria-busy');
      }
    }
    showCartError(message) {
      const error = this.querySelector('[data-fixture-cart-error]');
      if (!error) return;
      error.querySelector('[data-fixture-cart-message]').textContent = message || error.dataset.error;
      error.hidden = false;
    }
    async addToCart(form, opener) {
      if (this.cartPending || !form.reportValidity()) return;
      const button = form.querySelector('[data-fixture-add]');
      if (!button || button.disabled) return;
      const formData = new FormData(form);
      if (!formData.get('id')) return;
      this.cartPending = true;
      const label = button.textContent;
      const error = this.querySelector('[data-fixture-cart-error]');
      if (error) error.hidden = true;
      const controls = [...form.querySelectorAll('[data-fixture-option], input[name="quantity"], [data-fixture-add]')];
      const disabledStates = controls.map(control => control.disabled);
      controls.forEach(control => { control.disabled = true; });
      button.textContent = button.dataset.loading;
      this.setAttribute('aria-busy', 'true');
      let added = false;
      try {
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const sections = typeof cart?.getSectionsToRender === 'function' ? cart.getSectionsToRender() : [];
        if (sections.length) {
          formData.set('sections', sections.map(section => section.id).join(','));
          formData.set('sections_url', window.location.pathname);
          cart.setActiveElement?.(opener || button);
        }
        const response = await fetch(form.action, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          this.showCartError(data.description || data.message);
          return;
        }
        added = true;
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'fixture-studio',
              productVariantId: String(formData.get('id')),
              cartData: data
            });
          } catch {}
        }
        const canRender = typeof cart?.renderContents === 'function' && sections.length &&
          sections.every(section => typeof data.sections?.[section.id] === 'string' &&
            new DOMParser().parseFromString(data.sections[section.id], 'text/html').querySelector(section.selector || '.shopify-section'));
        if (canRender) {
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        } else {
          window.location.assign(this.dataset.cartUrl);
        }
      } catch {
        if (added) {
          window.location.assign(this.dataset.cartUrl);
        } else {
          this.showCartError(error?.dataset.uncertain);
        }
      } finally {
        this.cartPending = false;
        this.removeAttribute('aria-busy');
        controls.forEach((control, index) => { control.disabled = disabledStates[index]; });
        button.textContent = label;
      }
    }
    selectTab(index) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bie-lighting-collection"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('bie-lighting-collection')) {
  customElements.define('bie-lighting-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelectorAll('[data-lighting-view]').forEach((button) => {
        button.hidden = false;
        button.addEventListener('click', () => {
          const card = button.closest('[data-lighting-card]');
          const showingBack = card.classList.toggle('has-alt');
          button.setAttribute('aria-pressed', String(showingBack));
          button.querySelector('[data-lighting-view-label]').textContent = showingBack ? button.dataset.frontLabel : button.dataset.backLabel;
        });
      });
      const sortForm = this.querySelector('.bie-lighting__sort');
      if (sortForm) {
        sortForm.querySelector('.bie-lighting__sort-submit').hidden = true;
        sortForm.querySelector('select').addEventListener('change', () => sortForm.requestSubmit());
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
